// @i18n-ignore-start
export const ROW_SELECTOR_IDS = [
  'colors',
  'sizes',
  'prices',
  'fabrics',
  'materials',
  'categories',
  'stone_shapes',
  'jacket_styles',
  'lengths',
  'warmths',
  'activity',
  'sleeves',
  'occasions',
]
// @i18n-ignore-end

// The labels have been converted to the translation keys to be consumed at the UI layer
export const SORT_BY = {
  FEATURED: {
    labelKey: 'featured_v1',
    // @i18n-ignore
    label: 'Featured',
    // @i18n-ignore
    value: 'FEATURED',
  },
  PRICE_LOW_TO_HIGH: {
    labelKey: 'price_low',
    // @i18n-ignore
    label: 'Price Low',
    // @i18n-ignore
    value: 'PRICE_LOW_TO_HIGH',
  },
  PRICE_HIGH_TO_LOW: {
    labelKey: 'price_high',
    // @i18n-ignore
    label: 'Price High',
    // @i18n-ignore
    value: 'PRICE_HIGH_TO_LOW',
  },
  ALPHABETICALLY_A_Z: {
    labelKey: 'alphabetically_a_z',
    // @i18n-ignore
    label: 'Alphabetically: A-Z',
    // @i18n-ignore
    value: 'ALPHABETICALLY_A_TO_Z',
  },
  ALPHABETICALLY_Z_A: {
    labelKey: 'alphabetically_z_a',
    // @i18n-ignore
    label: 'Alphabetically: Z-A',
    // @i18n-ignore
    value: 'ALPHABETICALLY_Z_TO_A',
  },
  OLDEST_TO_NEWEST: {
    labelKey: 'oldest_first',
    // @i18n-ignore
    label: 'Oldest First',
    // @i18n-ignore
    value: 'OLDEST_TO_NEWEST',
  },
  NEWEST_TO_OLDEST: {
    labelKey: 'newest_first',
    // @i18n-ignore
    label: 'Newest First',
    // @i18n-ignore
    value: 'NEWEST_TO_OLDEST',
  },
  BEST_SELLER: {
    labelKey: 'best_seller_v1',
    // @i18n-ignore
    label: 'Best Seller',
    // @i18n-ignore
    value: 'BEST_SELLER',
  },
}

// New object for CLP filter experiment with updated labels
export const SORT_BY_CLP_EXPERIMENT = {
  ...SORT_BY,
  FEATURED: {
    labelKey: 'recommended_v1',
    label: 'Recommended',
    value: 'FEATURED',
  },
  PRICE_LOW_TO_HIGH: {
    labelKey: 'price_low_to_high',
    label: 'Price: Low to High',
    value: 'PRICE_LOW_TO_HIGH',
  },
  PRICE_HIGH_TO_LOW: {
    labelKey: 'price_high_to_low',
    label: 'Price: High to Low',
    value: 'PRICE_HIGH_TO_LOW',
  },
  BEST_SELLER: {
    labelKey: 'best_sellers',
    label: 'Best Sellers',
    value: 'BEST_SELLER',
  },
}

// Create a new sort options array for the experiment
export const SORT_OPTIONS_CLP_EXPERIMENT = [
  SORT_BY_CLP_EXPERIMENT.FEATURED,
  SORT_BY_CLP_EXPERIMENT.BEST_SELLER,
  SORT_BY_CLP_EXPERIMENT.PRICE_LOW_TO_HIGH,
  SORT_BY_CLP_EXPERIMENT.PRICE_HIGH_TO_LOW,
  SORT_BY_CLP_EXPERIMENT.NEWEST_TO_OLDEST,
  SORT_BY_CLP_EXPERIMENT.OLDEST_TO_NEWEST,
  // SORT_BY_CLP_EXPERIMENT.ALPHABETICALLY_A_Z,
  // SORT_BY_CLP_EXPERIMENT.ALPHABETICALLY_Z_A,
]

export type SortByKeys = keyof typeof SORT_BY

export const SORT_OPTIONS = [
  SORT_BY.FEATURED,
  SORT_BY.BEST_SELLER,
  SORT_BY.PRICE_LOW_TO_HIGH,
  SORT_BY.PRICE_HIGH_TO_LOW,
  SORT_BY.NEWEST_TO_OLDEST,
  SORT_BY.OLDEST_TO_NEWEST,
  // SORT_BY.ALPHABETICALLY_A_Z,
  // SORT_BY.ALPHABETICALLY_Z_A,
]

export const B2B_SELF_FUNDED_SORT_OPTIONS = [SORT_BY.FEATURED, SORT_BY.PRICE_LOW_TO_HIGH, SORT_BY.PRICE_HIGH_TO_LOW]

export const FEATURED = {
  NEW_ARRIVALS: {
    label: 'New Arrivals',
    value: 'NEW_ARRIVALS',
  },
  BEST_SELLERS: {
    label: 'Best Sellers',
    value: 'BEST_SELLERS',
  },
}

export const FEATURED_OPTIONS = [FEATURED.NEW_ARRIVALS, FEATURED.BEST_SELLERS]

export const COLORS = {
  WHITE: '#ffffff',
} as const

export enum FILTER_DROPDOWN_TYPES {
  CHECKBOX = 'checkbox',
  SORT = 'sort',
  CARD = 'card',
  COLOR = 'color',
}

export const MAX_FILTERS = 8
export const MAX_INLINE_FILTERS = 7
